import { ENTITY_ACTION_PERMISSIONS_QUERY } from "@app/shared-core/queries/entity-action-permissions.query";
import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";

/**
 * Selection set for the price list form and edit page. Each row's group selects only
 * `id name entityId enabled`: other group fields are not needed here.
 */
export const PRICE_LIST_FORM_QUERY = `
  id
  entityId
  name
  code
  currency
  rateBasis
  type
  rateModel
  durationRanges { minDays maxDays }
  groups {
    id
    group { id name entityId enabled }
    groupEnabled
    rateModel
    ratePerDay
    variableRates { minDays maxDays rate extraRate }
  }
  enabled
  createdAt
  updatedAt
  createdBy { ${CREATED_BY_QUERY} }
  ${ENTITY_ACTION_PERMISSIONS_QUERY}
`;
